import { useEffect, useState } from "react";

const GeneralToast = ({ type, message }) => {
  const [state, setState] = useState(true);

  function getThemeClass() {
    switch (type) {
      case "error":
        return "bg-red-500 text-white";
      case "success":
        return "bg-green-500 text-white";
      case "warning":
        return "bg-yellow-500 text-white";
      case "info":
        return "bg-blue-500 text-white";
      default:
        return "bg-white";
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setState(false);
    }, 10000);
  }, [state]);

  return state ? (
    <div
      className={`fixed inset-x-0 top-0 p-3 ${getThemeClass()} z-[999] m-4  rounded-lg text-center shadow-xl`}
    >
      <p className="block text-sm font-semibold">{message}</p>
    </div>
  ) : null;
};

export default GeneralToast;
